/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Existing_PlaceholderInputs */

const cs_sreality_seller_existing_placeholder = /** @type {(inputs: Sreality_Seller_Existing_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte makléře…`)
};

const en_sreality_seller_existing_placeholder = /** @type {(inputs: Sreality_Seller_Existing_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a seller…`)
};

/**
* | output |
* | --- |
* | "Select a seller…" |
*
* @param {Sreality_Seller_Existing_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_existing_placeholder = /** @type {((inputs?: Sreality_Seller_Existing_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Existing_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_existing_placeholder(inputs)
	return cs_sreality_seller_existing_placeholder(inputs)
});